import type { components } from '@pba/types-openapi-client';

export type Permissions = {
  createConferenceEvent?: boolean;
  createContentObject?: boolean;
  createTelehealthEvent?: boolean;
  createWebinarEvent?: boolean;
  requestTelehealthEvent?: boolean;
  viewNonProfitGiving?: boolean;
  viewProfitGiving?: boolean;
};

export const createPermissions = (data: components['schemas']['UserDetail']['permissions']): Permissions => ({
  createConferenceEvent: data.create_conference_event,
  createContentObject: data.create_content_object,
  createTelehealthEvent: data.create_telehealth_event,
  createWebinarEvent: data.create_webinar_event,
  requestTelehealthEvent: data.request_telehealth_event,
  viewNonProfitGiving: data.view_non_profit_giving,
  viewProfitGiving: data.view_profit_giving,
});
